import { useState } from "react"
import styled, { css } from "styled-components"

import { ReactComponent as IconTableCross } from "assets/svg/icon-table-cross.svg"
import { ReactComponent as IconTableSearch } from "assets/svg/icon-table-search.svg"

import styles from "./index.module.scss"

const TableSearchWrapper = styled.div<{ withLabel: boolean }>`
  display: inline-flex;
  color: #808080;
  cursor: pointer;

  ${({ withLabel }) =>
    withLabel &&
    css`
      width: 100%;
    `}

  svg {
    stroke: #808080;
    transition: 0.2s;
    margin-left: 2px;
  }
`

const SearchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  width: 100%;
`

export interface TableSearchContentProps {
  name?: string
  label?: string
  value: string
  onClear: () => void
  onInputChange: (value: string) => void
}

export const TableSearchContent = ({ name, label, value, onClear, onInputChange }: TableSearchContentProps) => {
  const [isActive, setActive] = useState(false)

  const handleClear = () => {
    onClear()
    setActive(false)
  }

  const handleActivate = () => {
    setActive(true)
  }

  return (
    <TableSearchWrapper withLabel={!!label} onClick={() => {}}>
      {isActive ? (
        <div className={styles.inputWrapper}>
          <input
            className={styles.inputSearch}
            placeholder="Search.."
            autoFocus
            defaultValue={value}
            onChange={event => onInputChange(event.currentTarget?.value)}
            name={name === "email" ? "emailField" : name}
          />
          <span className={styles.iconClear} onClick={handleClear}>
            <IconTableCross />
          </span>
        </div>
      ) : (
        <SearchContainer>
          {label && <span className={styles.label}>{label}</span>}
          <span className={styles.iconSearch} onClick={handleActivate}>
            <IconTableSearch />
          </span>
        </SearchContainer>
      )}
    </TableSearchWrapper>
  )
}
